import { Network } from '@glif/filecoin-address'

export const KNOWN_TYPE_1_ADDRESS = {
  [Network.MAIN]: 'f1ojyfm5btrqq63zquewexr4hecynvq6yjyk5xv6q',
  [Network.TEST]: 't1ojyfm5btrqq63zquewexr4hecynvq6yjyk5xv6q'
}
export const KNOWN_TYPE_3_ADDRESS = {
  [Network.MAIN]:
    'f3wigf2pezolpxu6z6724afsek5kbntsnjgn7zo745qn5volj2wgutbldgqxbblhshegzid2d25ev6tqabilsq',
  [Network.TEST]:
    't3wigf2pezolpxu6z6724afsek5kbntsnjgn7zo745qn5volj2wgutbldgqxbblhshegzid2d25ev6tqabilsq'
}

export const KNOWN_TYPE_0_ADDRESS = {
  [Network.TEST]: 't023667',
  [Network.MAIN]: 'f023667'
}
